import { styled } from '@mui/material/styles';
import { isDark } from 'global/styles';
import { List } from '@mui/material';

export const HContainer = styled('div')({});

export const HButtonContainer = styled('div')(({ theme }) => ({
  flexDirection: 'row',
  alignItems: 'center',
  marginTop: theme.spacing(2),
  marginBottom: theme.spacing(2),

  '& button': {
    margin: theme.spacing(1),
    marginBottom: 0,
  },
}));

export const HOpHeader = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  marginTop: theme.spacing(1),
  marginBottom: theme.spacing(1),
}));

export const HOpTitle = styled('div')(({ theme }) => ({
  fontSize: 20,
  color: theme.palette.text.primary,
  fontWeight: '500',
  marginLeft: theme.spacing(1),
}));

export const HList = styled(List)({});

export const HCollapseContainer = styled('div')(({ theme }) => ({
  padding: theme.spacing(2),
}));

export const HTitle = styled('div')({
  fontSize: 14,
  fontWeight: 'bold',
});

export const HListItem = styled('div', {
  shouldForwardProp: (prop) => prop !== 'opColor',
})(({ theme, opColor }) => ({
  marginBottom: 3,

  '& .MuiListItemButton-root': {
    backgroundColor: theme.palette.action.disabledBackground,
    borderLeft: opColor ? `3px solid ${opColor}` : undefined,
  },

  '& .MuiIcon-root, & .MuiSvgIcon-root': {
    color: isDark(theme) ? theme.palette.common.white : theme.palette.secondary.main,
    cursor: 'pointer',
    marginLeft: theme.spacing(1),

    '&.arrowIcon': {
      color: theme.palette.text.secondary,
    },
  },

  '@media print': {
    pageBreakAfter: 'always !important',
  },
  '& .iconContainer': {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
  },
}));

export const HBox = styled('div')(({ theme }) => ({
  width: '100%',
  marginBottom: theme.spacing(4),
  float: 'left',
  clear: 'both',
}));

export const HInnerHtml = styled('div', {
  shouldForwardProp: (prop) => !['hasImage', 'printView'].includes(prop),
})(({ theme, hasImage, printView }) => ({
  boxSizing: 'border-box',
  ...(hasImage && {
    width: printView ? '100%' : '50%',
    float: 'left',
    [theme.breakpoints.down('md')]: {
      width: '100% !important',
    },
  }),
}));

export const HImagesContainer = styled('div', {
  shouldForwardProp: (prop) => prop !== 'printView',
})(({ theme, printView }) => ({
  boxSizing: 'border-box',
  paddingLeft: printView ? 0 : theme.spacing(2),
  paddingRight: printView ? 0 : theme.spacing(2),
  float: printView ? undefined : 'right',
  width: printView ? '100%' : '50%',
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'top',
  flexWrap: 'wrap',

  '& .IMAGE': {
    marginRight: 3,
    marginBottom: 3,
    cursor: 'pointer',
  },
  [theme.breakpoints.down('md')]: {
    width: '100% !important',
  },
}));

export const HCreateTopContent = styled('div')({
  display: 'inline-block',

  '& .imgContainer': {
    float: 'left',
    width: '100%',
    paddingLeft: 0,
    paddingRight: 0,
  },
  '& .innerHtml': {
    width: '100%',
  },
});

export const HShowMore = styled('a')({
  cursor: 'pointer',
});
